import React from 'react';
import { Field } from 'formik';
import { Fields } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS } from '../Form/Form.types';
import { Props } from './RelatedToSelfEmployedIncome.types';

const RelatedToSelfEmployedIncome: React.FC<Props> = ({ prefix }) => {
  const getName = (field: FIELDS): string => {
    return `${prefix}.${FIELDS.RELATED_TO_SELF_EMPLOYED_SALARY}.${field}`;
  };

  return (
    <>
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.DIVIDENTS_INCOME}
        name={getName(FIELDS.DIVIDENTS_INCOME)}
        variant={VARIANTS_TYPES.CURRENCY}
      />
    </>
  );
};

export default RelatedToSelfEmployedIncome;
